import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { AppConfigService } from 'src/app/services/app-config.service';
import { map } from 'rxjs/operators';
import { ScheduleRequest, ScheduleUpdateRequest } from './scheduler.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SchedulerService {

  private apiUrl: string;

  private urlGetJobs: string = "/adm/scheduler/jobs";
  private urlScheduleJob: string = "/adm/scheduler/schedule";
  private urlPauseJob: string = "/adm/scheduler/pause";
  private urlResumeJob: string = "/adm/scheduler/resume";
  private urlDeleteJob: string = "/adm/scheduler/delete";
  private urlUpdateJob: string = "/adm/scheduler/update";
  private urlIsJobWithNamePresent: string = "/adm/scheduler/checkJobName";
  private urlStopJob: string = "/adm/scheduler/stop";
  private urlStartJobNow: string = "/adm/scheduler/start";
  private urlJobDetail: string = "/adm/scheduler/jobDetail";

  constructor(private _http: HttpClient, private _appConfig: AppConfigService) {
    this.apiUrl = _appConfig.config.servicesBaseUrl;
  }

  scheduleJob(scheduleRequest: ScheduleRequest): Observable<HttpResponse<any>> {
    const apiUrl = this._appConfig.config.servicesBaseUrl;
    return this._http.post<ScheduleRequest>(apiUrl + `/adm/scheduler/schedule`, scheduleRequest, { observe: 'response' });
  }

  updateJob(scheduleUpdateRequest: ScheduleUpdateRequest): Observable<HttpResponse<any>> {
    const apiUrl = this._appConfig.config.servicesBaseUrl;
    return this._http.put<ScheduleUpdateRequest>(apiUrl + `/adm/scheduler/update`, scheduleUpdateRequest, { observe: 'response' });
  }

  getJobs(): Observable<HttpResponse<any>> {
    const apiUrl = this._appConfig.config.servicesBaseUrl;
    return this._http.get<any>(apiUrl + `/adm/scheduler/jobs`, { observe: 'response' });
  }

  getJobTypes(): Observable<HttpResponse<any>> {
    const apiUrl = this._appConfig.config.servicesBaseUrl;
    return this._http.get<any>(apiUrl + `/adm/scheduler/jobTypes`, { observe: 'response' });
  }

  isJobWithNamePresent(jobName: string) {
    return this.getMethod(jobName, this.urlIsJobWithNamePresent);
  }

  pauseJob(jobName: string) {
    return this.getMethod(jobName, this.urlPauseJob);
  }

  resumeJob(jobName: string) {
    return this.getMethod(jobName, this.urlResumeJob);
  }

  deleteJob(jobName: string) {
    return this.getMethod(jobName, this.urlDeleteJob);
  }

  stopJob(jobName: string) {
    return this.getMethod(jobName, this.urlStopJob);
  }

  startJobNow(jobName: string) {
    return this.getMethod(jobName, this.urlStartJobNow);
  }

  jobDetail(jobName: string) {
    return this.getMethod(jobName, this.urlJobDetail);
  }

  private getMethod(jobName: string, urlName: string): Observable<HttpResponse<any>> {
    const apiUrl = this._appConfig.config.servicesBaseUrl;
    let params = new HttpParams();
    params = params.append('jobName', jobName);
    return this._http.get<any>(apiUrl + urlName, { params, observe: 'response' });
  }

}
